module.exports = __webpack_public_path__ + "static/media/quotesection_layout.1d1e5cfc.png";